module.exports = __webpack_public_path__ + "img/lantern-gsl.ee5edc36.svg";